export default {
  // Hero Section
  'sourcing.hero.title': 'Sourcing Center',
  'sourcing.hero.subtitle': 'Quick sourcing by region/scene/documentation, generate RFQ and match suppliers',
  'sourcing.hero.search.placeholder': 'Search products...',
  'sourcing.hero.search.role': 'Buyer Role',
  'sourcing.hero.search.country': 'Destination',
  'sourcing.hero.chip.stock': 'In Stock',
  'sourcing.hero.chip.mixed': 'Mixed Batch',
  'sourcing.hero.chip.lcl': 'LCL',
  'sourcing.hero.chip.docs': 'Complete Docs',
  'sourcing.hero.chip.custom': 'Customizable',

  // Quick Entry
  'sourcing.entry.belt.title': 'Source by Industrial Belt',
  'sourcing.entry.belt.cities': 'Foshan / Zhaoqing / Shanwei / Jieyang',
  'sourcing.entry.belt.tag1': 'Direct Sourcing',
  'sourcing.entry.belt.tag2': 'Advantage Categories',
  'sourcing.entry.belt.tag3': 'Response Time',
  'sourcing.entry.belt.cta': 'Enter Belt View',
  'sourcing.entry.scene.title': 'Source by Industry Scene',
  'sourcing.entry.scene.examples': 'Furniture Hardware / Cabinet Materials / Aluminum Ceiling',
  'sourcing.entry.scene.tag1': 'BOM Package',
  'sourcing.entry.scene.tag2': 'Scenario-based',
  'sourcing.entry.scene.tag3': 'One-stop',
  'sourcing.entry.scene.cta': 'Enter Scene View',

  // Tabs
  'sourcing.tab.industry': 'Industry Scenes',
  'sourcing.tab.industry.desc': 'BOM/Package',
  'sourcing.tab.sku': 'SKU Library',
  'sourcing.tab.sku.desc': 'Database Search',
  'sourcing.tab.supplier': 'Supplier Library',
  'sourcing.tab.supplier.desc': 'Factory/Trading',
  'sourcing.tab.rfq': 'RFQ',
  'sourcing.tab.rfq.desc': 'Templates',
  'sourcing.tab.custom': 'Custom Manufacturing',
  'sourcing.tab.custom.desc': 'Sample→Production',

  // View Switcher
  'sourcing.view.scene': 'Scene View',
  'sourcing.view.belt': 'Belt View',

  // Buyer Type
  'sourcing.buyer.wholesale': 'Wholesaler',
  'sourcing.buyer.platform': 'Platform Seller',

  // Filter Bar
  'sourcing.filter.supply': 'Supply Method',
  'sourcing.filter.supply.all': 'All',
  'sourcing.filter.supply.stock': 'In Stock',
  'sourcing.filter.supply.mixed': 'Mixed Batch',
  'sourcing.filter.supply.lcl': 'LCL',
  'sourcing.filter.supply.custom': 'Customizable',
  'sourcing.filter.moq': 'MOQ',
  'sourcing.filter.moq.all': 'All',
  'sourcing.filter.moq.trial': 'Trial (<100)',
  'sourcing.filter.moq.wholesale': 'Wholesale (100-1000)',
  'sourcing.filter.moq.bulk': 'Bulk (>1000)',
  'sourcing.filter.leadtime': 'Lead Time',
  'sourcing.filter.leadtime.all': 'All',
  'sourcing.filter.leadtime.7': '≤7 days',
  'sourcing.filter.leadtime.15': '≤15 days',
  'sourcing.filter.leadtime.30': '≤30 days',
  'sourcing.filter.docs': 'Documentation',
  'sourcing.filter.docs.all': 'All',
  'sourcing.filter.docs.complete': 'Complete',
  'sourcing.filter.docs.partial': 'Partial',
  'sourcing.filter.docs.building': 'In Progress',
  'sourcing.filter.sort': 'Sort By',
  'sourcing.filter.sort.recommended': 'Recommended',
  'sourcing.filter.sort.leadtime': 'Lead Time',
  'sourcing.filter.sort.docs': 'Documentation',
  'sourcing.filter.sort.price': 'Price',

  // SKU Card
  'sourcing.sku.moq': 'MOQ',
  'sourcing.sku.leadtime': 'Lead Time',
  'sourcing.sku.price': 'Price Range',
  'sourcing.sku.supplier': 'Supplier',
  'sourcing.sku.docs': 'Documentation',
  'sourcing.sku.factory': 'Factory',
  'sourcing.sku.trading': 'Trading',
  'sourcing.sku.addToRFQ': 'Add to RFQ',
  'sourcing.sku.sample': 'Request Sample',
  'sourcing.sku.detail': 'View Details',
  'sourcing.sku.days': 'days',
  'sourcing.sku.pieces': 'pcs',

  // RFQ Cart
  'sourcing.rfq.cart.title': 'RFQ Console',
  'sourcing.rfq.cart.items': 'items',
  'sourcing.rfq.cart.empty': 'No products',
  'sourcing.rfq.cart.country': 'Destination',
  'sourcing.rfq.cart.country.placeholder': 'Please select',
  'sourcing.rfq.cart.terms': 'Delivery Terms',
  'sourcing.rfq.cart.notes': 'Notes (packaging, labeling, documentation)',
  'sourcing.rfq.cart.notes.placeholder': 'Enter special requirements...',
  'sourcing.rfq.cart.submit': 'Submit RFQ',
  'sourcing.rfq.cart.match': 'Will match factories/traders and service packages',
  'sourcing.rfq.bom.title': 'BOM Package Recommendations',
  'sourcing.rfq.bom.add': 'Add All',

  // Scene Catalog
  'sourcing.scene.title': 'Industry Scenes',
  'sourcing.scene.furniture': 'Furniture Hardware & Accessories',
  'sourcing.scene.cabinet': 'Cabinet/Custom Home Materials',
  'sourcing.scene.panel': 'Panel Veneer & Edge Banding',
  'sourcing.scene.adhesive': 'Adhesive/Coating & Construction Materials',
  'sourcing.scene.plywood': 'Plywood/Multilayer Board & Base Materials',
  'sourcing.scene.ceiling': 'Aluminum Ceiling System & Accessories',
  'sourcing.scene.platform': 'Platform Hot Sellers',
  'sourcing.scene.mixed': 'One-stop Mixed Batch (LCL)',

  // Belt View
  'sourcing.belt.city': 'Industrial Belt City',
  'sourcing.belt.advantage': 'Advantage Categories',
  'sourcing.belt.capability': 'City Capabilities',
  'sourcing.belt.response': 'Response Time',
  'sourcing.belt.docs.rate': 'Documentation Rate',
  'sourcing.belt.countries': 'Countries Covered',
  'sourcing.belt.suppliers': 'Suppliers',
  'sourcing.belt.stock.rate': 'Stock Rate',
  'sourcing.belt.contact': 'Contact Regional Advisor',

  // Empty State
  'sourcing.empty.title': 'No Results Found',
  'sourcing.empty.desc': 'Try adjusting filters or browse recommended scenes',
  'sourcing.empty.relax': 'Relax Filters',
  'sourcing.empty.rfq': 'Publish RFQ',
  'sourcing.empty.recommended': 'Recommended Scenes',

  // Mobile
  'sourcing.mobile.viewRFQ': 'View RFQ',
  'sourcing.mobile.submitRFQ': 'Submit RFQ',
  'sourcing.mobile.cart.title': 'RFQ Cart',
  'sourcing.mobile.cart.empty': 'Cart is empty',
  'sourcing.mobile.cart.empty.desc': 'Start sourcing!',
  'sourcing.mobile.cart.selected': 'Selected',
  'sourcing.mobile.cart.continue': 'Continue Sourcing',

  // RFQ Templates
  'sourcing.rfq.template.title': 'Select RFQ Template',
  'sourcing.rfq.template.wholesale': 'Wholesale RFQ',
  'sourcing.rfq.template.wholesale.desc': 'For wholesalers, focus on stock/mixed batch/LCL/lead time',
  'sourcing.rfq.template.platform': 'Platform Sourcing RFQ',
  'sourcing.rfq.template.platform.desc': 'For platform sellers, focus on documentation/labeling/trial MOQ',
  'sourcing.rfq.template.project': 'Project RFQ',
  'sourcing.rfq.template.project.desc': 'For projects, focus on customization/quality/delivery',

  // RFQ Form
  'sourcing.rfq.form.step.product': 'Product Info',
  'sourcing.rfq.form.step.quantity': 'Quantity',
  'sourcing.rfq.form.step.delivery': 'Lead Time',
  'sourcing.rfq.form.step.terms': 'Delivery Terms',
  'sourcing.rfq.form.step.docs': 'Documentation & Compliance',
  'sourcing.rfq.form.step.submit': 'Submit',
  'sourcing.rfq.form.back': 'Back',
  'sourcing.rfq.form.next': 'Next',
  'sourcing.rfq.form.submit': 'Submit RFQ',

  // RFQ Success
  'sourcing.rfq.success.title': 'RFQ Submitted Successfully!',
  'sourcing.rfq.success.desc': 'We have matched suppliers and service packages for you',
  'sourcing.rfq.success.matched': 'Matched',
  'sourcing.rfq.success.suppliers': 'suppliers',
  'sourcing.rfq.success.services': 'Recommended Service Packages',
  'sourcing.rfq.success.view': 'View Matches',
  'sourcing.rfq.success.new': 'New RFQ',

  // Custom Manufacturing
  'sourcing.custom.title': 'Custom Manufacturing',
  'sourcing.custom.upload': 'Upload Drawings/Images',
  'sourcing.custom.timeline': 'Custom Process',
  'sourcing.custom.timeline.sample': 'Sampling',
  'sourcing.custom.timeline.confirm': 'Confirmation',
  'sourcing.custom.timeline.production': 'Production',
  'sourcing.custom.timeline.qc': 'QC',
  'sourcing.custom.timeline.export': 'Export',
  'sourcing.custom.options': 'Customization Options',
  'sourcing.custom.options.size': 'Size',
  'sourcing.custom.options.surface': 'Surface',
  'sourcing.custom.options.color': 'Color',
  'sourcing.custom.options.packaging': 'Packaging & Labeling',
  'sourcing.custom.generate': 'Generate Custom RFQ'
};